import React, {Component} from 'react';
import { Link } from 'react-router-dom';


const FooterBottom = () => {

  return (
    <div className="footer-bottom">
      <div className="copyright-text">© 2018 Jasons Wine & Spirits. All Rights Reserved</div>
    </div>
  )
}

export default FooterBottom;



// WEBPACK FOOTER //
// ./src/components/commons/footer/FooterBottom.js